import script from "./Input.vue?vue&type=script&setup=true&lang=js"
export * from "./Input.vue?vue&type=script&setup=true&lang=js"

import "./Input.vue?vue&type=style&index=0&id=9775a114&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/transfers/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9775a114"]])

export default __exports__